import * as actionTypes from 'constants/ActionTypes';

const cargoRealNames = (state = {
    items: [],
    isLoaded: false,
    searchText: '',
}, action) => {
    switch (action.type) {
    case actionTypes.GET_CARGO_REAL_NAMES.REQUEST:
        return {
            ...state,
            isLoaded: false,
        };
    case actionTypes.GET_CARGO_REAL_NAMES.SUCCESS: {
        const items = action.data.map(item => ({
            ...item,
            prevState: item,
            isUpdate: false,
        }));
        return {
            ...state,
            items,
            isLoaded: true,
        };
    }
    case actionTypes.GET_CARGO_REAL_NAMES.FAILURE:
        return {
            ...state,
            isLoaded: true,
        };
    case actionTypes.GET_CARGO_REAL_NAMES_PAGINATED.REQUEST:
        return {
            ...state,
            items: [],
            errors: [],
            isLoaded: false,
        };
    case actionTypes.GET_CARGO_REAL_NAMES_PAGINATED.SUCCESS: {
        const items = action.data.items.map(item => ({
            ...item,
            prevState: item,
            isUpdate: false,
        }));

        const { categories } = action.data;
        return {
            ...state,
            ...action.data,
            errors: [],
            items,
            isLoaded: true,
            categories,
        };
    }
    case actionTypes.GET_CARGO_REAL_NAMES_PAGINATED.FAILURE:
        return {
            ...state,
            errors: action.errors,
            isLoaded: true,
        };
        
    case actionTypes.DELETE_CARGO_REAL_NAME.REQUEST:
        return {
            ...state,
        };
    case actionTypes.DELETE_CARGO_REAL_NAME.SUCCESS: {
        const items = state.items.filter(item => !(item._id === action.item._id));

        return {
            ...state,
            items,
        };
    }
    case actionTypes.DELETE_CARGO_REAL_NAME.FAILURE:
        return {
            ...state,
        };

    case actionTypes.UPDATE_CARGO_REAL_NAME.REQUEST:
        const items = state.items.map((item) => {
            if (action.item._id === item._id) {
                return {
                    ...item,
                    isUpdate: false,
                    prevState: item,
                };
            }

            return item;
        });

        return {
            ...state,
            items,
        };
    case actionTypes.UPDATE_CARGO_REAL_NAME.SUCCESS: {
        const names = state.items.map((item) => {
            if (action.item._id === item._id) {
                return {
                    ...item,
                    isUpdate: false,
                };
            }

            return item;
        });

        return {
            ...state,
            items: names,
        };
    }
    case actionTypes.UPDATE_CARGO_REAL_NAME.FAILURE: {
        const names = state.items.map((item) => {
            if (action.item._id === item._id) {
                return {
                    ...item,
                    errors: action.errors,
                    isUpdate: true,
                };
            }
            return item;
        });

        return {
            ...state,
            items: names,
        };
    }
    
    case actionTypes.SAVE_STATUS_CARGO_REAL_NAME: {
        const names = state.items.map((item) => {
            if (action.item._id === item._id) {
                return action.item;
            }
            return item;
        });
        
        return {
            ...state,
            items: names,
        };
    }
    
    case actionTypes.CLEAR_STATUS_CARGO_REAL_NAME: {
        const names = state.items.map((item) => {
            if (action.item._id === item._id) {
                return {
                    ...item,
                    prevState: action.item,
                };
            }
            return item;
        });

        return {
            ...state,
            items: names,
        };
    }

    case actionTypes.SEARCH_CARGO_REAL_NAMES:
        return {
            ...state,
            searchText: action.search,
        };

    case actionTypes.UPDATE_TAGS_DATA_IN_ROW:
        const index = state.items.findIndex(item => item._id === action._id);
        state.items[index].tags = action.tags || [];
        return {
            ...state,
        };
    default:
        return state;
    }
};

export default cargoRealNames;



// WEBPACK FOOTER //
// ./app/reducers/cargoes/realNames.js